export default "<template>\n\n  <KButton\n    primary\n    disabled\n    text=\"Basic link\"\n    appearance=\"basic-link\"\n  />\n\n</template>\n";